<template>
    <Alert v-if="alertContent || loadingMood" :loadingMood="loadingMood" :alertContent="alertContent" @close="handleClose"/>
    <div id="login-container">
        <img src="../assets/appIcons/Pics/Flag.png" id="flag" alt="">
        <div class="row">
            <div class="col-lg-5">
                <div id="login-form-content">
                    <form v-on:submit.prevent="handelSubmit">
                        <div id="title">ورود</div>
                        <div class="form-group">
                            <div class="input-group">
                                <div class="text-field">
                                    <input id="email-input" v-model="data.email" class="form-control" type="text" required>
                                    <label>آدرس ایمیل</label>
                                </div>
                            </div>
                            <div class="input-group">
                                <div class="text-field">
                                    <input id="password-input" v-model="data.password" class="form-control" :type="visibility" required>
                                    <label>رمز عبور</label>
                                    <a id="eye-icon" v-if="data.password" v-on:mouseover="showPassword"  v-on:mouseleave="hidePassword">
                                        <span v-if="visibility=='password'">
                                             <span class="iconify" data-icon="clarity:eye-hide-line" data-inline="false"></span>
                                        </span>
                                        <span v-if="visibility=='text'">
                                              <span class="iconify" data-icon="akar-icons:eye" data-inline="false" style="color: #fe7063"></span>
                                        </span>
                                    </a>
                                    <div class="forget-password" v-on:click="$router.push('/forget-password')">فراموشی رمز عبور</div>
                                </div>
                            </div>
                        </div>
                        <button type="submit" style="display: none">submit</button>
                    </form>
                    <div>
                        <button type="submit"  v-on:click="handelSubmit()" class="btn btn-success btn-block">ورود</button>
                        <div id="detail-txt">
                            تازه وارد هستید؟
                            <a v-on:click="$router.push('/user-signup')">
                                ثبت نام کنید.
                            </a>
                        </div>
                    </div>

                </div>
            </div>
            <div class="col-7 img-content">
                <div id="img-content"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import Alert from "../components/Alert"
    export default {
        name: "Login",
        data () {
            return {
                visibility: 'password',
                error:null,
                data:{password:null,email:null},
                alertContent:null,
                loadingMood:false,
                loginResult:false
            }
        },
        components:{
            Alert
        },
        methods: {
            showPassword() {
                this.visibility='text';
            },
            hidePassword() {
                this.visibility='password';
            },
            async handelSubmit() {
                try {
                    this.loadingMood=true;
                    let response = await axios.post('api/authentication/login' ,this.data);
                    this.loadingMood=false;
                    localStorage.setItem('token',response.data.token);
                    if(response.data.completionRegistrationStatus){
                        localStorage.setItem('email',response.data.user.email);
                        localStorage.setItem('unique_id',response.data.user.unique_id);
                        localStorage.setItem('loginStatus','true');
                        this.$store.state.loginStatus = true;
                        this.loginResult = true;
                        this.alertContent={
                            message: 'شما با موفقیت وارد شدید!',
                            imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                            buttonType:'link',//link
                            buttonText:'ورود به داشبورد',
                            buttonLink:'/user-panel',///personal-info
                            waitingMode:false
                        };
                    }else{
                       this.$router.push('/personal-info');
                    }
                } catch (error) {
                    this.loadingMood=false;
                    this.alertContent={
                        message: 'خطا در انجام عملیات!',
                        notice:error.response.data.errors,
                        imageUrl:require('../assets/appIcons/Pics/CanadaAzIran/Icon/Mail.png'),
                        buttonType:'close',
                        buttonText:'تایید',
                        closeButtonShow:true,
                        buttonLink:'',///personal-info
                        waitingMode:false
                    };
                }
            },
            handleClose(){
                if(this.loginResult){
                    this.$router.push('/user-panel');
                }else{
                    this.alertContent = '';
                }
            }


        },

    }
</script>

<style lang="scss" scoped>
    .forget-password{
        font-family: IRANSans;
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
        margin-top: 6px;
        width: 100%;
        cursor: pointer;
    }

    #eye-icon{
       position: absolute;
        top: 12px;
        right: 15px;
    }
    .iconify{
        font-size: 20px;
    }
    button:hover{
        background-color: #fe7063;
        border: none;
    }


    #detail-txt{
        width: 100%;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #162336;
    }
    #detail-txt>a{
        color: #162336;
        text-decoration: underline;
    }
    button{
        max-width: 305px;
        width: 100%;
        height: 50px;
        margin: 0 0 15px;
        padding: 11px 97px 11px 98px;
        border-radius: 5px;
        background-color: #162336;
        font-size: 18px;
    }
    form>.form-group{
        margin-top: 50px;
    }
    #email-input , #password-input{
        text-align: left;
        padding-right: 15px;
    }

    .text-field {
        position: relative;
        margin: 10px 2.5px 20px 2.5px;
    }


    input:focus {
        border: thin solid #32cd32;
        border-bottom: solid medium #32cd32;
        background-color:#fff;
    }

    label {
        position: absolute;
        pointer-events: none;
        right: 10px;
        top: 5px;
        transition: 0.2s;
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        opacity: 1;
    }

    input:focus ~ label, input:valid ~ label {
        top: -12px;
        right: 15px;
        font-size: small;
        color:  #fe7063;
        padding:0 5px 0 5px;
        background-color: white;

    }



    .text-field{
        width: 100%;
    }
    input{
        text-align: right;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        color: #162336;
        max-width: 300px;
        width: 100%;
        height: 40px;
        border-radius: 5px!important;
        opacity: 0.5;
        border: solid 0.5px #162336;
    }
    #title{
        font-size: 22px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: right;
        color: #1a1a1a;
    }

    input:focus{
        border: solid 2px #fe7063!important;
    }
    *:focus {
        border: solid 0.5px #162336!important;
    }
    #login-form-content{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;
        top: 50%;
        transform: translateY(-50%);
        width: 100%;
        max-width: 370px;
        margin: auto;
        height: 518px;
        padding: 15px 30px 20px;
        border-radius: 10px;
        box-shadow: 0 0 12px 0 rgba(22, 35, 54, 0.2);
        background-color: #ffffff;
    }
    #login-form-content>form{
        margin-top: 50px;
    }
    #flag{
        left: 0;
        top: 0;
        opacity: 0.05;
        height: 100%;
        width: 100%;
        position: absolute;
    }
    #img-content{
        width: 100%;
        height: 517px;
        margin: 35px auto;
        background-image: url("../assets/appIcons/Pics/Login.png");
        background-size: cover;
        background-repeat: no-repeat;
    }
    #login-container{
        position: relative;
        height: auto;
        background-color: white;
        width: 100%;
        max-width: 970px;
        padding: 30px;
        margin: auto;
        margin-bottom: 50px;
        border-radius: 10px;
    }

    /*login-container*/

    @media (max-width: 1000px) {
        #flag{
            display: none;
        }
        #login-container{
            background-color: transparent;
        }
        .img-content{
            display: none;
        }
    }
</style>